import { combineReducers } from 'redux'

import deleteNode from './owners/delete'
import get from './owners/get'
import list from './owners/list'
import post from './owners/post'
import put from './owners/put'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/owners.js